module.exports = __webpack_public_path__ + "img/event-img.4244540f.jpg";